import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class SellItemSummeryReportModel {
  @Expose()
  public name?: string;

  @Expose()
  public count?: number;

  @Expose()
  public date?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(SellItemSummeryReportModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(SellItemSummeryReportModel, camelcaseKeys(data, { deep: true }) as SellItemSummeryReportModel[], { excludeExtraneousValues: true });
  }
}
